var React = require('react');

var Input = require('../input');
var css = require('./module.scss');

/**
 * 使用方法：
 * <Datepicker name="time"
    wtype="2"
    size='lg'
    value='2018-04-11 20:0:00'
    dateFmt={'yyyy-MM-dd HH:mm:ss'}
    onChange={this.dateChange}/>
 */

var Datepicker = React.createClass({

    getTarget: function() {
        return this.refs[this.props.name].getTarget();
    },

    getValue: function() {
        return this.refs[this.props.name].getValue();
    },

    datePicker: function(e) {
        if (this.props.disabled) {
            return;
        }

        var _this = this;
        setTimeout(function() {
            window.WdatePicker({
                skin: 'twoer',
                el: _this.refs[_this.props.name].getTarget(),
                dateFmt: _this.props.dateFmt || 'yyyy-MM-dd',
                hmsMenuCfg: _this.props.hmsMenuCfg || undefined,
                onpicked: function(datePicker) {
                    var value = datePicker.el.value;
                    _this.props.onChange && _this.props.onChange(value);
                },
                oncleared: function(datePicker) {
                    _this.props.onChange && _this.props.onChange();
                },
                maxDate: _this.props.maxDate || '',
                minDate: _this.props.minDate || '',
                minTime: _this.props.minTime || undefined,
                maxTime: _this.props.maxTime || undefined,
                mchanging: _this.props.mchanging || undefined,
                disabledDates: _this.props.disabledDates || []
            });
        }, 0);
    },

    clickIcon: function() {
        this.datePicker();
    },

    valueChange: function(e) {
        var value = e.target.value;
        this.props.onChange && this.props.onChange(value);
    },

    render: function() {
        var cls = ['fp-datepicker', this.props.className];
        if (this.props.size) {
            cls.push('fp-datepicker-' + this.props.size);
        }
        return (
            <div className={cls.join(' ')}>
                <Input
                    ref={this.props.name}
                    name={this.props.name}
                    value={this.props.value}
                    onClick={this.datePicker}
                    onKeyUp={this.valueChange}
                    placeholder={this.props.placeholder}
                    size={this.props.size}
                    wtype={this.props.wtype}
                    autoComplete="off"
                    disabled={this.props.disabled}
                    readonly={this.props.readonly}
                />
                <i onClick={this.clickIcon}></i>
            </div>
        );
    }

});

module.exports = Datepicker;



// WEBPACK FOOTER //
// ./component/datepicker/index.js